var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-5{fill:none;}.cls-2{mix-blend-mode:lighten;opacity:0.5;}.cls-4{fill:#a3ccee;}.cls-5{stroke:#e7eced;stroke-miterlimit:10;stroke-width:1.6px;}.cls-6{fill:#ffd15c;}.cls-7{fill:#76b72a;}.cls-8{fill:#5a4146;}.cls-9{fill:#add47f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.46,
    y: 24.62,
    width: 137.85,
    height: 108.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.46,
    y: 24.62,
    width: 137.85,
    height: 108.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8,
    y: 21.66,
    width: 144,
    height: 116.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.55,50.63A16.17,16.17,0,1,1,47.39,34.46,16.17,16.17,0,0,1,63.55,50.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.85,96.28l-2.47-2.74L113.84,66.46,88,94.78l13.5,13.49,9.89,9.88h34.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.93,128H72l-9.89-9.87-27-27L12.93,110.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 12.93,
    y: 118.15,
    width: 132.92,
    height: 12.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M101.5,108.27l-27-27L32.62,118.15h78.77Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaImage);
export default __webpack_public_path__ + "static/media/ka_image.6af18a228730d12a406399777ff03b55.svg";
export { ForwardRef as ReactComponent };